import React, { useEffect, useState } from 'react';
import keyloackicon from '../../../assets/images/keyloackicon.svg';
import { Button, Form, Spinner, Table } from 'react-bootstrap';
import './surveys.css';
import { useNavigate, useParams } from 'react-router-dom';
import { GetEmergencySurveyStatusListAsync } from '../../../services/surveyService/SurveyService';
import { toast } from 'react-toastify';
import { SurveyStatusItemDto } from '../../../interfaces/survey/SurveyDtos';
import { useAuth } from '../../../firebase/AuthProvider';
import moment from 'moment';
import { PaginationDto } from '../../../interfaces/Employee/Employee';
import Pagination from '../../ui/Pagination/Pagination';
import { ParticipantUnderMeDto } from '../../../interfaces/Participant';
import { GetAllParticipantUnderMeAsync } from '../../../services/participantServices/ParticipantService';

const Surveys: React.FC = () => {
    const { currentUser } = useAuth();
    const { participantId } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(false);
    const [surveyList, setSurveyList] = useState<SurveyStatusItemDto[]>([]);
    const [surveyListCount, setSurveyListCount] = useState<number>(0);
    const [pagination, setPagination] = useState<PaginationDto>({ pageNumber: 1, pageSize: 10 });
    const [participantList, setParticipantList] = useState<ParticipantUnderMeDto[]>([]);

    const [selectedParticipant, setSelectedParticipant] = useState<number | null>(null);

    useEffect(() => {
        getAllParticipantUnderMe();
    }, [currentUser]);

    useEffect(() => {
        currentUser?.getIdToken().then((token) => {
            if (token) {
                const participantIdforFetch = participantId
                    ? Number(participantId) : selectedParticipant
                        ? selectedParticipant : 0;
                GetEmergencySurveyStatusList(token, participantIdforFetch)
            }
        })
    }, [pagination, selectedParticipant]);

    const GetEmergencySurveyStatusList = (token: string, participant_Id?: number) => {
        setLoading(true);
        GetEmergencySurveyStatusListAsync(token, pagination.pageNumber, pagination.pageSize, participant_Id).then((res) => {
            if (res.success) {
                setSurveyList(res.data.items);
                setSurveyListCount(res.data.totalCount);
            } else {
                toast.error(res.message);
            }
        }).catch((err) => {
            toast.error(err.message);
        }).finally(() => {
            setLoading(false);
        })
    }

    const getAllParticipantUnderMe = async () => {
        if (!currentUser) return;
        const token = await currentUser.getIdToken();
        setParticipantList([]);
        GetAllParticipantUnderMeAsync(token, currentUser.uid).then((res) => {
            if (res.success) {
                setParticipantList(res.data);
            }
        });
    };

    const onClickStartSurvey = (surveyName: string, instanceId: string, participant_ID: string) => {
        switch (surveyName) {
            case 'EMERGENCY_SURVEY_1':
                navigate(`/prestormsurvey/${participant_ID}/${instanceId}`);
                break;
            case 'EMERGENCY_SURVEY_2':
                navigate(`/relocationsurvey/${participant_ID}/${instanceId}`);
                break;
            case 'EMERGENCY_SURVEY_3':
                navigate(`/poststormsurvey/${participant_ID}/${instanceId}`);
                break;
            default:
                break;
        }
    }

    const onPageChange = (pageNum: number) => {
        setPagination((prev) => ({
            ...prev,
            pageNumber: pageNum
        }))
    }

    const resetPageSize = (pageNumber: number, pageSize: number) => {
        setPagination({
            pageNumber: pageNumber,
            pageSize: pageSize
        })
    }

    return (
        <>
            {/* {loading && <Loader />} */}
            <div className="common_card">
                <div className="top">
                    <div className="top_bar_tittle">
                        <h2>Surveys</h2>
                    </div>
                    {
                        !participantId
                        &&
                        (
                            <div className="cir_fillter">
                                <div className="cir_fillter_filled">
                                    <Form.Group
                                        className="mb-0 flex items-center gap-3"
                                        controlId="participantSelect"
                                    >
                                        <Form.Label className="mb-0 whitespace-nowrap font-medium">
                                            Filter by Participants
                                        </Form.Label>

                                        <Form.Select
                                            aria-label="Select participant"
                                            className="sm_input min-w-[17rem]"
                                            value={selectedParticipant ?? ""}
                                            onChange={(e) =>
                                                setSelectedParticipant(
                                                    e.target.value ? Number(e.target.value) : null
                                                )
                                            }
                                        >
                                            <option value="">All</option>
                                            {participantList.map((p) => (
                                                <option key={p.id} value={p.id}>
                                                    {p.firstName} {p.lastName}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </div>
                            </div>

                        )
                    }

                </div>

                <div className="row">
                    <div className="col-lg-12 mb-xl-0 mb-4">
                        <Table responsive className='common_table'>
                            <thead>
                                <tr>
                                    <th>Survey Title</th>
                                    <th>Survey Name</th>
                                    <th>Participant Name</th>
                                    <th>Status</th>
                                    <th>Status Date</th>
                                    <th className='action_th'>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ?
                                    (<tr ><td colSpan={6} className='text-center p-5'> <Spinner size='sm' /> Loading...</td></tr>)
                                    : (
                                        surveyList.length === 0 ?
                                            (<tr className='text-center'><td colSpan={4}>No Data Found</td></tr>)
                                            : (
                                                surveyList.map((item, index) => {
                                                    let statusLabel;
                                                    let actionLabel;
                                                    switch (item.status) {
                                                        case 'Sent':
                                                            statusLabel = <p>Not Started</p>;
                                                            actionLabel = <Button variant='primary' className='btn_sm' onClick={() => onClickStartSurvey(item.surveyName, item.instanceId, item.participantId)}>Start</Button>;
                                                            break;
                                                        case 'Responded':
                                                            statusLabel = <p>Completed</p>;
                                                            actionLabel = <Button variant='secondary' className='btn_sm' onClick={() => onClickStartSurvey(item.surveyName, item.instanceId, item.participantId)}>View</Button>
                                                            break;
                                                    }
                                                    return (
                                                        <tr key={index}>
                                                            <td>{item.surveyTitle}</td>
                                                            <td>{item.surveyName}</td>
                                                            <td>{item.participantName}</td>
                                                            <td>{statusLabel}</td>
                                                            <td>{moment(item.lastStatusChange).format('DD/MM/YYYY')}</td>
                                                            <td className='action_btn'>
                                                                {actionLabel}
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            )
                                    )}

                                {/* <tr>
                                    <td>Policy and Procedures</td>
                                    <td>2</td>
                                    <td>Not Started</td>
                                    <td>May 28th, 2025</td>
                                    <td className='action_btn'>
                                        <button><img style={{ width: '1.5rem' }} src={tabledownloadicon} alt="tabledownloadicon" /></button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>HIPPA Law and Staff Ethics</td>
                                    <td>2</td>
                                    <td>Not Started</td>
                                    <td>May 28th, 2025</td>
                                    <td className='action_btn'>
                                        <Button style={{ minWidth: 0 }} variant='primary' className='btn_sm'>Start</Button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Policy and Procedures</td>
                                    <td>2</td>
                                    <td>Not Started</td>
                                    <td>May 28th, 2025</td>
                                    <td className='action_btn'>
                                        <button><img style={{ width: '1.5rem' }} src={tabledownloadicon} alt="tabledownloadicon" /></button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>HIPPA Law and Staff Ethics</td>
                                    <td>2</td>
                                    <td>Not Started</td>
                                    <td>May 28th, 2025</td>
                                    <td className='action_btn'>
                                        <Button style={{ minWidth: 0 }} variant='primary' className='btn_sm'>Start</Button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Policy and Procedures</td>
                                    <td>2</td>
                                    <td>Not Started</td>
                                    <td>May 28th, 2025</td>
                                    <td className='action_btn'>
                                        <button><img style={{ width: '1.5rem' }} src={tabledownloadicon} alt="tabledownloadicon" /></button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>HIPPA Law and Staff Ethics</td>
                                    <td>2</td>
                                    <td>Not Started</td>
                                    <td>May 28th, 2025</td>
                                    <td className='action_btn'>
                                        <Button style={{ minWidth: 0 }} variant='primary' className='btn_sm'>Start</Button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Policy and Procedures</td>
                                    <td>2</td>
                                    <td>Not Started</td>
                                    <td>May 28th, 2025</td>
                                    <td className='action_btn'>
                                        <button><img style={{ width: '1.5rem' }} src={tabledownloadicon} alt="tabledownloadicon" /></button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>HIPPA Law and Staff Ethics</td>
                                    <td>2</td>
                                    <td>Not Started</td>
                                    <td>May 28th, 2025</td>
                                    <td className='action_btn'>
                                        <Button style={{ minWidth: 0 }} variant='primary' className='btn_sm'>Start</Button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Policy and Procedures</td>
                                    <td>2</td>
                                    <td>Not Started</td>
                                    <td>May 28th, 2025</td>
                                    <td className='action_btn'>
                                        <button><img style={{ width: '1.5rem' }} src={tabledownloadicon} alt="tabledownloadicon" /></button>
                                    </td>
                                </tr> */}
                            </tbody>
                        </Table>
                    </div>
                    {/* <div className="col-lg-12 col-xl-4">
                        <div className="common_card">
                            <div className="top top_bar_flx border_tittle mby_16">
                                <div className="top_bar_tittle">
                                    <h2>SCS Promotion Requirements <span><img src={keyloackicon} alt="keyloackicon" /></span></h2>
                                    <p>You must have 2+ years of SC experience or a master’s degree to access these trainings.</p>
                                </div>
                            </div>
                            <ul className="scs_promotion_list">
                                <li>Lorem Ipsum is simply dummy text</li>
                                <li>90L, UPOC, Logs & Attachments (4HR)</li>
                                <li>PC Toolkit & Approval (4HR)</li>
                                <li>POC Review Tool & Certification (2HR)</li>
                                <li>EPSDT Appendix & Handbook (5HR)</li>
                                <li>Tracking and Supervision (1HR)</li>
                            </ul>
                        </div>
                    </div> */}
                </div>
                {(surveyListCount && surveyListCount > 0) ? (
                    <Pagination
                        currentPage={pagination.pageNumber}
                        totalPages={Math.ceil(surveyListCount / pagination.pageSize)}
                        onPageChange={onPageChange}
                        pageSize={pagination.pageSize}
                        resetPageSize={resetPageSize}
                    />
                ) : <></>}
            </div>
        </>
    );
};

export default Surveys;